import { render, staticRenderFns } from "./Recovery.vue?vue&type=template&id=61f5689f"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"
import style0 from "./Recovery.vue?vue&type=style&index=0&id=61f5689f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports